// Class: starling.filters.DropShadowFilter

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;
var $import = require("./../../import_stub").default;
var $extend = require("./../../extend_stub").default;
function starling_filters_FragmentFilter() {return require("./../../starling/filters/FragmentFilter");}
function starling_filters_CompositeFilter() {return require("./../../starling/filters/CompositeFilter");}
function starling_filters_BlurFilter() {return require("./../../starling/filters/BlurFilter");}

// Constructor

var DropShadowFilter = function(distance,angle,color,alpha,blur,quality,inner,knockout) {
	if(knockout == null) {
		knockout = false;
	}
	if(inner == null) {
		inner = false;
	}
	if(quality == null) {
		quality = 0.5;
	}
	if(blur == null) {
		blur = 1.0;
	}
	if(alpha == null) {
		alpha = 0.5;
	}
	if(color == null) {
		color = 0;
	}
	if(angle == null) {
		angle = 0.785;
	}
	if(distance == null) {
		distance = 4.0;
	}
	(starling_filters_FragmentFilter().default).call(this);
	this._compositeFilter = new (starling_filters_CompositeFilter().default)();
	this._blurFilter = new (starling_filters_BlurFilter().default)(blur,blur);
	this._distance = distance;
	this._angle = angle;
	this.set_color(color);
	this.set_alpha(alpha);
	this.set_quality(quality);
	this.set_inner(inner);
	this.set_knockout(knockout);
	this.updatePadding();
}

// Meta

DropShadowFilter.__name__ = "starling.filters.DropShadowFilter";
DropShadowFilter.__isInterface__ = false;
DropShadowFilter.__super__ = (starling_filters_FragmentFilter().default);
DropShadowFilter.prototype = $extend((starling_filters_FragmentFilter().default).prototype, {
	dispose: function() {
		this._blurFilter.dispose();
		this._compositeFilter.dispose();
		(starling_filters_FragmentFilter().default).prototype.dispose.call(this);
	},
	process: function(painter,helper,input0,input1,input2,input3) {
		var shadow = this._blurFilter.process(painter,helper,input0);
		var result = this._compositeFilter.process(painter,helper,input0,shadow);
		helper.putTexture(shadow);
		return result;
	},
	get_numPasses: function() {
		return this._blurFilter.get_numPasses() + this._compositeFilter.get_numPasses();
	},
	updatePadding: function() {
		var offsetX = Math.cos(this._angle) * this._distance;
		var offsetY = Math.sin(this._angle) * this._distance;
		this._compositeFilter.setOffsetAt(1,offsetX,offsetY);
		var blurPadding = this._blurFilter.get_padding();
		var left = blurPadding.get_left();
		var right = blurPadding.get_right();
		var top = blurPadding.get_top();
		var bottom = blurPadding.get_bottom();
		if(offsetX > 0) {
			right += offsetX;
		} else {
			left -= offsetX;
		}
		if(offsetY > 0) {
			bottom += offsetY;
		} else {
			top -= offsetY;
		}
		this.get_padding().setTo(left,right,top,bottom);
	},
	get_color: function() {
		return this._compositeFilter.getColorAt(1);
	},
	set_color: function(value) {
		if(this.get_color() != value || !this._compositeFilter.getReplaceColorAt(1)) {
			this._compositeFilter.setColorAt(1,value,true);
			this.setRequiresRedraw();
		}
		return value;
	},
	get_alpha: function() {
		return this._compositeFilter.getAlphaAt(1);
	},
	set_alpha: function(value) {
		if(this.get_alpha() != value) {
			this._compositeFilter.setAlphaAt(1,value);
			this.setRequiresRedraw();
		}
		return value;
	},
	get_distance: function() {
		return this._distance;
	},
	set_distance: function(value) {
		if(this._distance != value) {
			this._distance = value;
			this.setRequiresRedraw();
			this.updatePadding();
		}
		return value;
	},
	get_angle: function() {
		return this._angle;
	},
	set_angle: function(value) {
		if(this._angle != value) {
			this._angle = value;
			this.setRequiresRedraw();
			this.updatePadding();
		}
		return value;
	},
	get_blur: function() {
		return this._blurFilter.get_blurX();
	},
	set_blur: function(value) {
		if(this.get_blur() != value) {
			this._blurFilter.set_blurX(this._blurFilter.set_blurY(value));
			this.setRequiresRedraw();
			this.updatePadding();
		}
		return value;
	},
	get_quality: function() {
		return this._blurFilter.get_quality();
	},
	set_quality: function(value) {
		if(this.get_quality() != value) {
			this._blurFilter.set_quality(value);
			this.setRequiresRedraw();
			this.updatePadding();
		}
		return value;
	},
	get_inner: function() {
		return this._inner;
	},
	set_inner: function(value) {
		this._inner = value;
		this._compositeFilter.setModeAt(1,DropShadowFilter.getMode(this._inner,this._knockout));
		this._compositeFilter.setInvertAlphaAt(1,this._inner);
		this.setRequiresRedraw();
		return value;
	},
	get_knockout: function() {
		return this._knockout;
	},
	set_knockout: function(value) {
		this._knockout = value;
		this._compositeFilter.setModeAt(1,DropShadowFilter.getMode(this._inner,this._knockout));
		this.setRequiresRedraw();
		return value;
	}
});
DropShadowFilter.prototype.__class__ = DropShadowFilter.prototype.constructor = $hxClasses["starling.filters.DropShadowFilter"] = DropShadowFilter;

// Init

Object.defineProperties(DropShadowFilter.prototype,{ color : { get : function () { return this.get_color (); }, set : function (v) { return this.set_color (v); }}, alpha : { get : function () { return this.get_alpha (); }, set : function (v) { return this.set_alpha (v); }}, distance : { get : function () { return this.get_distance (); }, set : function (v) { return this.set_distance (v); }}, angle : { get : function () { return this.get_angle (); }, set : function (v) { return this.set_angle (v); }}, blur : { get : function () { return this.get_blur (); }, set : function (v) { return this.set_blur (v); }}, quality : { get : function () { return this.get_quality (); }, set : function (v) { return this.set_quality (v); }}, inner : { get : function () { return this.get_inner (); }, set : function (v) { return this.set_inner (v); }}, knockout : { get : function () { return this.get_knockout (); }, set : function (v) { return this.set_knockout (v); }}});

// Statics

DropShadowFilter.getMode = function(inner,knockout) {
	if(knockout) {
		if(inner) {
			return "insideKnockout";
		} else {
			return "outsideKnockout";
		}
	} else if(inner) {
		return "inside";
	} else {
		return "outside";
	}
}


// Export

exports.default = DropShadowFilter;